import { createModel } from '@rematch/core';
import { RootModel } from './RootState';
import type { AssistantHomeItem } from '../models/AssistantHomeItem';

export type HomeState = {
    homeItems: AssistantHomeItem[];
};

const initialState: HomeState = {
    homeItems: [
        {
            id: 'p1',
            iconId: 'help',
            text: 'Preguntar sobre este producto',
            footerText: 'Pregunta',
            featureType: 'product-detail',
            visibleInPageTypes: ['product']
        },
        {
            id: 'b',
            iconId: 'search',
            text: 'Buscar productos',
            footerText: 'Busca',
            featureType: 'product-search-by-text-menu',
            hiddenInPageTypes: []
        },
        {
            id: 'c',
            iconId: 'camera',
            text: 'Busca subiendo tu imagen',
            footerText: 'Busca',
            featureType: 'product-search-by-image-menu',
            hiddenInPageTypes: []
        },

        {
            id: 'p2',
            iconId: 'help',
            text: 'Ver productos similares',
            footerText: 'Descubre',
            featureType: 'product-search-similar',
            visibleInPageTypes: ['product']
        },
        {
            id: 'p3',
            iconId: 'help',
            text: 'Ver productos que combinan',
            footerText: 'Descubre',
            featureType: 'product-search-combinations',
            visibleInPageTypes: ['product']
        },
        {
            id: 'p4',
            iconId: 'help',
            text: 'Crea looks con este producto',
            footerText: 'Descubre',
            featureType: 'product-mix-and-match',
            visibleInPageTypes: ['product']
        },
        {
            id: 'e',
            iconId: 'camera',
            text: 'Ver novedades',
            footerText: 'Descubre',
            featureType: 'product-search-new',
            hiddenInPageTypes: []
        }
    ]
};

export const homeState = createModel<RootModel>()({
    state: initialState,
    reducers: {
        reset() {
            return initialState;
        }
    }
});
